import Alpine from "https://cdn.jsdelivr.net/npm/alpinejs@3.15.6/+esm"
import {
  animate,
  stagger,
  createTimeline,
  random,
} from "https://cdn.jsdelivr.net/npm/animejs@4.3.5/+esm"

import Swiper from "https://cdn.jsdelivr.net/npm/swiper@12.1.3/+esm"
import Navigation from "https://cdn.jsdelivr.net/npm/swiper@12.1.3/modules/navigation.min.mjs"
import Autoplay from "https://cdn.jsdelivr.net/npm/swiper@12.1.3/modules/autoplay.min.mjs"
import EffectFade from "https://cdn.jsdelivr.net/npm/swiper@12.1.3/modules/effect-fade.min.mjs"

import * as Shareon from "https://cdn.jsdelivr.net/npm/shareon@2.8.1/+esm"

import { sampleSize } from "https://cdn.jsdelivr.net/npm/es-toolkit@1.45.1/dist/array/sampleSize.mjs"
import { shuffle } from "https://cdn.jsdelivr.net/npm/es-toolkit@1.45.1/dist/array/shuffle.mjs"

document.addEventListener("DOMContentLoaded", function () {
  Alpine.start()
  // setTimeout(() => {
  blink()
  // }, 150)
  hoverBlink()
})

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    blink()
  }
})

window.addEventListener("beforeunload", () => {
  // setTimeout(() => {
  blink({ unblink: true })
  // }, 300)
})

document.addEventListener("alpine:init", () => {
  Alpine.directive(
    "sizing",
    (el, { expression }, { evaluateLater, cleanup }) => {
      const setValue = evaluateLater(expression)

      const update = () => {
        const rect = el.getBoundingClientRect()
        setValue({
          width: rect.width,
          height: rect.height,
          top: rect.top,
          left: rect.left,
          right: rect.right,
          bottom: rect.bottom,
        })
      }

      const observer = new ResizeObserver(() => update())
      observer.observe(el)

      window.addEventListener("scroll", update, { passive: true })

      cleanup(() => {
        observer.disconnect()
        window.removeEventListener("scroll", update)
      })
    },
  )
})

Alpine.store("cart", {
  // Store actions
  data: {},
  ...window.__ShopifyCart,

  lastestCart: null,
  inProcessing: false,

  cartModal: false,

  showModal() {
    this.cartModal = true
  },

  hideModal() {
    this.cartModal = false
  },

  updateStore(json) {
    this.data = json
    this.original_total_price = json.original_total_price
    this.total_price = json.total_price
    this.total_discount = json.total_discount
    this.item_count = json.item_count
    this.item_count_ = `(${json.item_count})`
    this.items = json.items
    this.currency_symbol = json.currency_symbol || this.currency_symbol
    this.items_subtotal_price = json.items_subtotal_price
  },

  updateLatest() {
    this.updateStore(this.lastestCart)
  },

  // Cart actions
  addCart(
    items = [
      // {
      //   id: 36110175633573,
      //   quantity: 1,
      // },
    ],
  ) {
    this.inProcessing = true
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        this.getCart()
        this.inProcessing = false
        this.showModal()
        return response.json()
      })
      .catch((error) => {
        this.inProcessing = false
        return error
      })
  },
  getCart() {
    this.inProcessing = true
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.inProcessing = false
        this.lastestCart = json
        this.updateLatest()
      })
      .catch((error) => {
        this.inProcessing = false
        return error
      })
  },
  updateCart(
    updates = {
      // 794864053: 2,
      // 794864233: 3,
    },
  ) {
    this.inProcessing = true
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.inProcessing = false
        this.updateStore(json)
        return json
      })
      .catch((error) => {
        this.inProcessing = false
        return error
      })
  },

  // Quantity
  increaseQuantity(index) {
    this.items[index].quantity += 1
    this.updateQuantity()
  },
  decreaseQuantity(index) {
    if (this.items[index].quantity > 0) {
      this.items[index].quantity -= 1
      this.updateQuantity()
    }
  },
  clearQuantity(index) {
    this.items[index].quantity = 0
    this.updateQuantity()
  },
  updateQuantity() {
    let updates = {}
    this.items.forEach((item) => {
      updates[item.variant_id] = item.quantity
    })

    this.updateCart(updates)
  },

  // Price utilities
  priceDisplay(price) {
    return `${this.currency_symbol}${(parseInt(price) / 100).toFixed(2)}`
  },

  getPrice(item) {
    if (item.original_price === item.discounted_price) {
      return `${this.priceDisplay(item.discounted_price)}`
    } else {
      return `<span class="line-through">${this.priceDisplay(
        item.original_price,
      )}</span> ${this.priceDisplay(item.discounted_price)}`
    }
  },

  getSubtotalPrice(item) {
    if (item.original_line_price === item.line_price) {
      return `${this.priceDisplay(item.line_price)}`
    } else {
      return `<span class="line-through">${this.priceDisplay(
        item.original_line_price,
      )}</span> ${this.priceDisplay(item.line_price)}`
    }
  },

  totalAll() {
    if (this.original_total_price === this.total_price) {
      return `${this.priceDisplay(this.total_price)}`
    } else {
      return `<span class="line-through">${this.priceDisplay(
        this.original_total_price,
      )}</span> ${this.priceDisplay(this.total_price)}`
    }
  },
})

Alpine.data("__add_cart", () => ({
  init() {},
  state: "normal", // added
  addCart(id) {
    this.state = "adding"

    let item = [
      {
        id: id,
        quantity: 1,
      },
    ]

    Alpine.store("cart")
      .addCart(item)
      .then((json) => {
        this.state = "added"
      })
      .catch((err) => {
        this.state = "failed"
      })
      .finally(() => {
        setTimeout(() => {
          this.state = "normal"
        }, 1000)
      })
  },
}))

Alpine.data("bicep_nav", () => ({
  logoEl: null,
  menuEl: null,
  isHovered: false,
  menuActive: false,
  init() {
    this.logoEl = this.$refs.logo
    this.menuEl = this.$refs.menu

    const menuEls = this.$refs["desktop-menu"].querySelectorAll("ul li")

    this.$refs["desktop-menu"].addEventListener("mouseover", () => {
      if (!this.isHovered) {
        this.isHovered = true
        animate(menuEls, {
          height: ["calc(var(--spacing) * 0)", "calc(var(--spacing) * 6)"],
          delay: stagger(50),
          easing: "easeIn",
          duration: 150,
        })
      }
    })

    this.$refs["desktop-menu"].addEventListener("mouseleave", () => {
      animate(menuEls, {
        height: ["calc(var(--spacing) * 6)", "calc(var(--spacing) * 0)"],
        delay: stagger(50),
        easing: "easeOut",
        duration: 100,
        onComplete: () => {
          this.isHovered = false
        },
      })
    })

    // mobile

    this.menusLength = parseInt(this.$refs.el.dataset.menuLength)

    this.tlIn = createTimeline({
      autoplay: false,
      onBegin: () => {
        this.mobileMenuClipPath = `inset(0 0 0% 0)`
        this.showMobileMenu = true
      },
      onBegin: () => {
        this.mobileMenuClipPath = `inset(0 0 100% 0)`
        this.showMobileMenu = true
      },
    })
    this.tlOut = createTimeline({
      autoplay: false,
      onComplete: () => {
        this.showMobileMenu = false
      },
    })

    for (let i = 0; i < this.menusLength; i++) {
      this.tlIn.call(() => {
        this.mobileMenuClipPath = `inset(0 0 ${100 - (100 / this.menusLength) * (i + 1)}% 0)`
      }, 50 * i)
      this.tlOut.call(() => {
        this.mobileMenuClipPath = `inset(0 0 ${(100 / this.menusLength) * (i + 1)}% 0)`
      }, 50 * i)
    }
  },

  menusLength: 0,
  showMobileMenu: false,
  mobileMenuClipPath: `inset(0 0 0% 0)`,
  tlIn: null,
  tlOut: null,
  toggleMobileMenu() {
    if (this.showMobileMenu) {
      this.tlOut.restart()
    } else {
      this.tlIn.restart()
    }
  },
}))

Alpine.data("bicep_product", () => ({
  swiper: null,
  currentSlider: 0,

  currentVariantIndex: -1,
  currentVariant: null,

  currentQuantity: 1,

  productVariants: null,
  productVariantsObj: null,
  productMedia: null,

  init() {
    this.productVariants = JSON.parse(this.$refs.el.dataset.variants)
    this.productVariantsObj = Object.fromEntries(
      this.productVariants.map((val, index) => [val.id, { index, ...val }]),
    )

    this.productMedia = JSON.parse(this.$refs.el.dataset.media)

    const first = this.$refs.el.dataset.first_available_variant

    if (first && first !== null && first !== "null") {
      const variant = JSON.parse(first)
      const indexedVariant = variant && this.productVariantsObj[variant.id]

      if (indexedVariant) {
        this.currentVariant = indexedVariant
        this.currentVariantIndex = indexedVariant.index
      }
    }

    this.swiper = new Swiper(this.$refs.slider, {
      modules: [Navigation],
      speed: 100,
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next,
      },
    })

    this.swiper.on("slideChange", () => {
      this.currentSlider = this.swiper.realIndex
    })
  },
  selectVariant(id, index) {
    const variant = this.productVariantsObj[id]
    this.currentVariant = variant || null
    this.currentVariantIndex = variant ? index : -1

    if (!variant) return

    if (this.currentVariant.featured_media) {
      const mediaId = this.currentVariant.featured_media.id
      const target = document.querySelector(`[data-media-id="${mediaId}"]`)

      if (target) {
        const sliderIndex = Number(target.dataset.index)
        this.slideToLoop(sliderIndex)
      }
    }

    this.currentQuantity = 1
  },

  get addCartText() {
    if (this.currentVariant?.available) {
      if (this.addCartAction) {
        return this.addCartState
      } else {
        return "Add to Cart"
      }
    } else {
      return "Sold out"
    }
  },
  get addCartClass() {
    if (
      this.currentVariantIndex < 0 ||
      !this.currentVariant?.available ||
      this.addCartAction
    ) {
    } else {
      return "hover:bg-b-store hover:text-black"
    }
  },
  slideTo(index) {
    this.swiper.slideToLoop(index)
  },
  addCartAction: false,
  addCartState: "",
  addCart() {
    this.addCartAction = true
    this.addCartState = "Adding..."

    let items = [
      {
        id: this.currentVariant.id,
        quantity: this.currentQuantity,
      },
    ]

    Alpine.store("cart")
      .addCart(items)
      .then((json) => {
        this.addCartState = "Added"
        setTimeout(() => {
          this.addCartAction = false
        }, 150)
      })
      .catch((err) => {
        this.addCartState = "Falied :("
        setTimeout(() => {
          this.addCartAction = false
        }, 150)
      })
  },
}))

Alpine.data("bicep_share", () => ({
  supportWebShare: false,
  showDropdown: false,
  init() {
    this.supportWebShare = !!navigator.share
    Shareon.init()
  },
  handleDropdown() {
    if (!this.supportWebShare) {
      this.showDropdown = !this.showDropdown
    }
  },
}))

Alpine.data("bicep_carousel", () => ({
  autoplay: true,
  autoplayDelay: 5000,
  speed: 300,
  init() {
    this.autoplay = this.$refs.slider.dataset.autoplay === "true"
    this.autoplayDelay = parseInt(this.$refs.slider.dataset.autoplayDelay)
    this.speed = parseInt(this.$refs.slider.dataset.speed)

    this.swiper = new Swiper(this.$refs.slider, {
      modules: [Navigation, Autoplay, EffectFade],
      autoplay: this.autoplay
        ? {
            delay: this.autoplayDelay,
          }
        : false,
      speed: this.speed,
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    })
  },
}))

Alpine.data("bicep_push_block", () => ({
  minHeight: -1,
  menuHeight: -1,
  blockTop: -1,
  blockLeft: -1,
  init() {
    // minHeight
    const minHeightObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.minHeight = entry.contentRect.height
      }
    })
    minHeightObserver.observe(document.querySelector("#bicep-index"))

    const menuObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.menuHeight = entry.contentRect.height
      }
    })
    menuObserver.observe(document.querySelector("#desktop-menu"))

    const elPosition = () => {
      this.blockLeft = this.$refs.el.getBoundingClientRect().left
      this.blockTop = this.$refs.el.getBoundingClientRect().top
    }

    elPosition()
    window.addEventListener("scroll", elPosition, { passive: true })
  },
  get blockStyle() {
    const realMenuHeight = Math.max(this.menuHeight, this.minHeight)

    if (this.minHeight > 0 && this.menuHeight > 0) {
      if (this.blockLeft < 400 && this.blockTop - realMenuHeight <= 0) {
        return {
          height:
            Math.min(realMenuHeight - this.blockTop, realMenuHeight) + "px",
        }
      } else {
        return {}
      }
    }
  },
}))

Alpine.data("bicep_store_selector", () => ({
  showModal: false,
  targetStore: null,
  stores: {
    eu: { name: "EU Store", url: "https://store-eu.bicepmusic.com" },
    us: { name: "US Store", url: "https://store-us.bicepmusic.com" },
    uk: { name: "UK Store", url: "https://store.bicepmusic.com" },
  },
  get currentStoreHost() {
    return this.$refs.el.dataset.storeHost || window.location.hostname
  },
  get currentStoreName() {
    const store = Object.values(this.stores).find(
      (store) => new URL(store.url).hostname === this.currentStoreHost,
    )
    return store?.name || this.$refs.el.dataset.storeName
  },
  get remainingStores() {
    return Object.values(this.stores).filter(
      (store) =>
        new URL(store.url).hostname !== this.currentStoreHost &&
        store.url !== this.targetStore?.url,
    )
  },
  get targetStoreRegion() {
    const entry = Object.entries(this.stores).find(
      ([, store]) => store.url === this.targetStore?.url,
    )
    return entry ? entry[0].toUpperCase() : ""
  },
  get hideDays() {
    const days = Number(this.$refs.el.dataset.hideDays)
    return Number.isFinite(days) && days > 0 ? days : 0
  },
  get dismissalKey() {
    return `bicep_store_selector_dismissed:${this.currentStoreHost}`
  },
  isDismissed() {
    if (!this.hideDays) return false
    try {
      const dismissedAt = Number(localStorage.getItem(this.dismissalKey))
      return (
        dismissedAt > 0 && Date.now() < dismissedAt + this.hideDays * 86400000
      )
    } catch {
      return false
    }
  },
  dismissModal() {
    if (!this.showModal) return
    if (this.hideDays) {
      try {
        localStorage.setItem(this.dismissalKey, String(Date.now()))
      } catch {}
    }
    this.showModal = false
  },
  previousOverflow: null,
  init() {
    this.$watch("showModal", (isOpen) => {
      if (isOpen) {
        this.previousOverflow = document.documentElement.style.overflow
        document.documentElement.style.overflow = "hidden"
      } else {
        this.restoreScroll()
      }
    })
    if (!this.isDismissed()) this.getInfo()
  },
  restoreScroll() {
    if (this.previousOverflow === null) return
    document.documentElement.style.overflow = this.previousOverflow
    this.previousOverflow = null
  },
  destroy() {
    this.restoreScroll()
  },
  storeForCountry(country) {
    const code = country.toUpperCase()
    // Ireland is served by the UK store.
    if (code === "IE") return this.stores.uk
    if (
      [
        "DE",
        "AT",
        "BE",
        "FR",
        "IT",
        "LU",
        "NL",
        "PL",
        "ES",
        "FI",
        "SE",
        "CH",
      ].includes(code)
    ) {
      return this.stores.eu
    }
    if (["US", "CA", "MX", "AR"].includes(code)) {
      return this.stores.us
    }
    return this.stores.uk
  },
  async getInfo() {
    try {
      const root = window.Shopify?.routes?.root || "/"
      const response = await fetch(
        `${root}browsing_context_suggestions.json?country[enabled]=true`,
      )
      if (!response.ok) return
      const result = await response.json()
      const country = result?.detected_values?.country?.handle
      if (typeof country !== "string" || !/^[a-z]{2}$/i.test(country)) return

      this.targetStore = this.storeForCountry(country)
      // Compare store domains: Shopify's selected market may differ from the store.
      this.showModal =
        this.currentStoreHost !== new URL(this.targetStore.url).hostname
    } catch (error) {
      console.warn("Unable to determine the recommended store", error)
    }
  },
}))

function blink({ unblink = false, target = document } = {}) {
  // scope = document
  const colors = [
    // "home",
    "music",
    "store",
    "news",
    "fmb",
    "live",
    "about",
    "projects",
  ]
  const targets = target.querySelectorAll("[blink]")

  for (const target in targets) {
    if (!Object.hasOwn(targets, target)) continue

    const el = targets[target]

    if (!isInViewport(el)) {
      if (unblink) {
        // el.setAttribute("blink-cloak")
        // el.setAttribute("blink-cloak-text")
      } else {
        el.removeAttribute("blink-cloak")
        el.removeAttribute("blink-cloak-text")
      }
      continue
    }

    // const randomPick = targets.length > 5 ? Math.random() > 0.4 : true
    const randomPick = true

    if (!randomPick) {
      if (unblink) {
        // el.setAttribute("blink-cloak")
      } else {
        el.removeAttribute("blink-cloak")
      }
      continue
    }

    let targetColor = el.getAttribute("blink-bg")

    if (targetColor === "home") {
      targetColor = "music"
    }

    // get random seeds
    const colorSet = new Set(colors)
    colorSet.delete(targetColor)

    const randomColors = shuffle(
      sampleSize(Array.from(colorSet), targets.length > 5 ? random(1, 6) : 6),
    )
    const randomTimer = shuffle(
      Array.from(
        { length: 18 },
        // targets.length > 5 ? 20 : 10
        (v, i) => (i + 1) * 25,
      ),
    )

    const tl = createTimeline({
      autoplay: false,
      onBegin: () => {
        if (unblink) {
        } else {
          el.removeAttribute("blink-cloak")
        }
      },
      onComplete: () => {
        if (unblink) {
          el.setAttribute("blink-cloak-text", true)
          el.setAttribute("blink-cloak", true)
          el.style.backgroundColor = `transparent`
        } else {
          el.style.removeProperty("background-color")
          el.removeAttribute("blink-cloak-text")
        }
      },
    })

    tl.call(() => {
      if (unblink) {
      } else {
        el.style.backgroundColor = `transparent`
      }
    }, 0)

    for (let i = 0; i < randomColors.length; i++) {
      const color = randomColors[i]
      tl.call(() => {
        el.style.backgroundColor = `var(--color-b-${color})`
      }, randomTimer[i])
    }

    tl.play()
  }
}

function hoverBlink() {
  const colors = [
    // "home",
    "music",
    "store",
    "news",
    "fmb",
    "live",
    "about",
    "projects",
  ]

  const els = document.querySelectorAll("[blink-hover]")

  for (const el of els) {
    let targetColor = el.dataset.blinkHoverColor

    if (targetColor === "home") {
      targetColor = "music"
    }

    el.addEventListener(
      "mouseenter",
      (e) => {
        // get random seeds
        const colorSet = new Set(colors)
        colorSet.delete(targetColor)

        const randomColors = shuffle(Array.from(colorSet))
        const randomTimer = shuffle(
          Array.from(
            { length: 12 },
            // targets.length > 5 ? 20 : 10
            (v, i) => (i + 1) * 25,
          ),
        )

        const tl = createTimeline({
          autoplay: false,
          onBegin: () => {},
          onComplete: () => {
            el.style.removeProperty("background-color")
          },
        })

        for (let i = 0; i < randomColors.length; i++) {
          const color = randomColors[i]
          tl.call(() => {
            el.style.backgroundColor = `var(--color-b-${color})`
          }, randomTimer[i])
        }

        tl.play()
      },
      { passive: true },
    )
  }
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect()

  const vh = window.innerHeight || document.documentElement.clientHeight
  const vw = window.innerWidth || document.documentElement.clientWidth

  const verticalInView = rect.bottom > 0 && rect.top < vh
  const horizontalInView = rect.right > 0 && rect.left < vw

  return verticalInView && horizontalInView
}

// recommendations

function loadProductRecommendationsIntoSection() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(
    ".product-recommendations",
  )
  if (productRecommendationsSection === null) {
    return
  }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit
  // Build request URL
  var requestUrl =
    baseUrl +
    "?section_id=product-recommendations&product_id=" +
    productId +
    "&limit=" +
    limit
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest()
  request.open("GET", requestUrl)
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div")
      container.innerHTML = request.response
      const id = productRecommendationsSection.parentElement.id
      productRecommendationsSection.parentElement.innerHTML =
        container.querySelector(".product-recommendations").innerHTML

      blink({ target: document.querySelector("#" + id) })
    }
  }
  request.send()
}
// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection()
  }
})
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection()
